// Module
var code = "<span ng-click=\"$ctrl.display($event)\" class=\"br-body-2\">{{::$ctrl.offer | score}}</span> ";
// Exports
export default code;